import { render } from "./ManuelleAufgabenBoxWiedervorlageModal.pug?vue&type=template&id=a4c6e3fc&lang=pug"
import script from "./ManuelleAufgabenBoxWiedervorlageModal.js?vue&type=script&lang=js"
export * from "./ManuelleAufgabenBoxWiedervorlageModal.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__